function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.2334 16.7598H14.2334V14.7598H4.2334V16.7598Z",
  fill: "#3DB9FE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2334 12.7598H4.2334V10.7598H14.2334V12.7598Z",
  fill: "#3DB9FE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.2334 8.75977H8.2334V6.75977H4.2334V8.75977Z",
  fill: "#3DB9FE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.2334 0.759766C1.57654 0.759766 0.233398 2.10291 0.233398 3.75977V17.7598C0.233398 19.4166 1.57654 20.7598 3.2334 20.7598H15.2334C16.8903 20.7598 18.2334 19.4166 18.2334 17.7598V7.75977C18.2334 3.89377 15.0994 0.759766 11.2334 0.759766H3.2334ZM3.2334 2.75977H10.2334V7.75977H16.2334V17.7598C16.2334 18.3121 15.7857 18.7598 15.2334 18.7598H3.2334C2.68111 18.7598 2.2334 18.3121 2.2334 17.7598V3.75977C2.2334 3.20748 2.68111 2.75977 3.2334 2.75977ZM12.2334 2.85978C13.8447 3.18687 15.1747 4.28882 15.8174 5.75977H12.2334V2.85978Z",
  fill: "#3DB9FE"
});

var SvgFile = function SvgFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file.55543b04.svg";
export { ForwardRef as ReactComponent };